module.exports = __webpack_public_path__ + "media/landing_page/us-98c6e25d.png";